module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "pt1",
      "epub:type": "part",
      "role": "doc-part"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "PT",
    attrs: {
      "id": "pt1"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "11",
      "id": "pg_11",
      "role": "doc-pagebreak"
    }
  }, [_c('samp', {
    staticClass: "SANS_Avenir_Light_229"
  }, [_vm._v("ZERO WASTE")]), _vm._v(" "), _c('samp', {
    staticClass: "SANS_Avenir_Black_B_229"
  }, [_vm._v("MAKES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "opener-intro"
  }, [_c('samp', {
    staticClass: "SANS_Milliard_Thin_229"
  }, [_vm._v("From cleaning cloths to ingenious storage, find a project that appeals to you from the following collection and start your journey to zero waste.")])]), _vm._v(" "), _c('figure', {
    staticClass: "IMG-NOBOT"
  }, [_c('span', {
    attrs: {
      "aria-label": "10",
      "id": "pg_10",
      "role": "doc-pagebreak"
    }
  }, [_c('img', {
    staticClass: "img100",
    attrs: {
      "alt": "",
      "src": "images/pg10.jpg"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02826ec8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part1.vue
// module id = 78
// module chunks = 0